import { cityFields } from './city/city-fields.js';
import { cotationBlocs } from './cotation/cotation-blocs.js';
import { dayActivities } from './day/day-activities.js';
import { images } from './images/images.js';
import { program } from './program/program.js';
import { print } from './print/print.js';
import { tracking } from './tracking/tracking.js';

import './service/service.scss';

export function tripplanner() {
  cityFields();
  cotationBlocs();
  dayActivities();
  images();
  program();
  print();
  tracking();
}
